import { downloadFile, getIdOrNull, requestMultipart, requestWithPromise } from '..'
import { HttpMethods, makeQueryStringFromObject } from '../apiHelper'
import moment from 'moment'
import { isFunction } from 'lodash'
import apiClient from './apiClient'
import { API_DATE } from '../momentjs'

const XLSX_FORMAT = 'xlsx'
const CSV_FORMAT = 'csv'
const SUPPORTED_EXPORT_FORMATS = [XLSX_FORMAT, CSV_FORMAT]

export const downloadAssistantMassImportTemplate = (user, language) => {
  return downloadFile(
    `/export/assistants/template${makeQueryStringFromObject({ language })}`,
    'assistants_template.xlsx',
    user
  )
}

export const downloadSpreadSheet = (fileName, user) => {
  downloadFile(
    `/spreadsheet/download/${fileName}`,
    fileName,
    user,
    HttpMethods.GET
  )
}

export const exportMaccsInternshipsByPeriod = (user, parameters) => {
  return apiClient.post(user, 'export/maccs-internships/by-period', parameters)
}

export const getMaccsInternshipsShifts = (body, user) => {
  return requestWithPromise(
    '/export/maccs-internships/shifts',
    HttpMethods.POST,
    body,
    user
  )
}

export const getJob = (jobId, user) => {
  return requestWithPromise(
    `/job-result/${jobId}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const importAssistants = (file, user, language = 'fr') => {
  return requestMultipart(
    '/import/assistants',
    HttpMethods.POST,
    { file, language },
    user,
    true
  ).then(response => response.blob()).then(blob => {
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.download = 'assistants_import_result.xlsx'
    document.body.appendChild(a)
    a.click()
    a.remove()
  })
}

export const makeExport = (exportRoute, user, parameters, onError, onSuccess, refreshRate) => {
  exportRoute(user, parameters).then(json => {
    if (json?.job) {
      getDocument(json.job, user, onError, onSuccess, refreshRate)
    } else if (isFunction(onError)) {
      onError(json)
    }
  })
}

export const getDocument = async (jobId, user, onError, onSuccess, refreshRate) => {
  const maxIteration = 10
  const interval = { ref: null, iteration: 0 }

  interval.ref = setInterval(() => {
    interval.iteration++

    apiClient.get(user, `job-result/${jobId}`).then(json => {
      clearInterval(interval.ref)

      return downloadSpreadsheet(json.data.result, user)
    }).then(() => {
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    }).catch(response => {
      if (interval.iteration === maxIteration) {
        clearInterval(interval.ref)

        if (typeof onError === 'function') {
          onError(response)
        }
      }
    })
  }, refreshRate ?? 1500)
}

export const downloadSpreadsheet = (fileName, user) => downloadFile(
  '/spreadsheet/download/' + fileName,
  fileName,
  user,
  HttpMethods.GET
)

export class ExportParameters {
  constructor ({ format }) {
    if (!format || !SUPPORTED_EXPORT_FORMATS.includes(format)) {
      format = XLSX_FORMAT
    }

    this.format = format
  }

  toRequestBody () {
    return {
      format: this.format
    }
  }
}

export const exportInstitutionQuotas = (user, institution, { format, startDate, endDate, language, sectorIds = [] }) => {
  return apiClient.post(user, `export/institutions/${getIdOrNull(institution)}/quotas`, { format, startDate, endDate, language, sectorIds })
}

export class PeriodExportParameters extends ExportParameters {
  constructor ({ format, startDate, endDate }) {
    super({ format })

    this.startDate = moment(startDate ?? null)
    this.endDate = moment(endDate ?? null)
  }

  toRequestBody () {
    return {
      end: this.endDate.format(API_DATE),
      format: this.format,
      start: this.startDate.format(API_DATE)
    }
  }
}
